    import type React from "react"
import { Modal, View, StyleSheet } from "react-native"
import { Text, useTheme } from "react-native-paper"
import { TableBase } from "./TableBase"
import type { TableProps } from "../../types/table"

interface ExpandedTableProps extends TableProps {
    visible: boolean
    onDismiss: () => void
}

export const ExpandedTable: React.FC<ExpandedTableProps> = ({ visible, onDismiss, ...tableProps }) => {
    const theme = useTheme()

    return (
        <Modal visible={visible} onRequestClose={onDismiss} animationType="slide" presentationStyle="fullScreen">
            <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
                {/* <View style={[styles.header, { backgroundColor: theme.colors.elevation.level2 }]}>
                    <Text variant="titleLarge" style={{ color: theme.colors.onSurface }}>
                        {tableProps.title}
                    </Text>
                </View> */}
                <TableBase 
                    {...tableProps}                     
                />
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: "rgba(255, 255, 255, 0.12)",
    },
})
